
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 7L7.56 9 6 7.721","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M15 8c0 .893-.978 1.584-1.3 2.36-.334.805-.144 1.983-.75 2.59-.607.606-1.785.416-2.59.75C9.585 14.022 8.894 15 8 15c-.893 0-1.585-.978-2.361-1.3-.805-.334-1.983-.144-2.589-.75-.606-.607-.416-1.785-.75-2.59C1.978 9.585 1 8.894 1 8c0-.893.978-1.585 1.3-2.36.334-.806.144-1.983.75-2.59.607-.606 1.785-.416 2.59-.75C6.414 1.978 7.106 1 8 1c.893 0 1.585.978 2.36 1.3.806.334 1.983.144 2.59.75.606.607.416 1.785.75 2.59.322.775 1.3 1.467 1.3 2.36z","stroke":"#8F7A61","stroke-width":"1.5","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    